<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <p class="title">{{ i18n.statistics[iso] }}</p>
        <!-- <p class="subtitle">Hero subtitle</p> -->
      </div>
    </section>
    <section style="margin-top: 30px">
      <b-tabs v-model="tabFilters" position="is-centered">
        <b-tab-item>
          <template #header>
            <b-icon icon="filter" pack="fas" type="is-info"></b-icon>
            <b>{{ i18n.filters[iso] }}</b>
          </template>
          <div class="columns is-multiline">
            <div class="column is-3">
              <b-field label-position="on-border" :label="i18n.indicator[iso]">
                <b-select
                  v-model="advancedFilters.Indicador"
                  expanded
                  @input="changeDateIndicator"
                >
                  <option :value="null"></option>
                  <option
                    v-for="ind in indicators"
                    :value="ind.id"
                    :key="ind.id"
                  >
                    {{ ind.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field
                label-position="on-border"
                :label="FechaIndicador || i18n.date[iso]"
              >
                <b-datepicker
                  v-model="advancedFilters.Fecha"
                  placeholder="DD/MM/YYYY"
                  :min-date="minDate"
                  :max-date="maxDate"
                  :locale="iso"
                  range
                  icon="calendar"
                  icon-pack="fas"
                >
                </b-datepicker>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field label-position="on-border" :label="i18n.breakdown[iso]">
                <b-select v-model="advancedFilters.Desglose" expanded>
                  <option :value="null"></option>
                  <option :value="11">
                    {{ i18n.concentrated[iso] }}
                  </option>
                  <option :value="12">
                    {{ i18n.concentrated[iso] }} - {{ i18n.day[iso] }}
                  </option>
                  <option :value="13">
                    {{ i18n.concentrated[iso] }} - {{ i18n.month[iso] }}
                  </option>
                  <option :value="21">
                    {{ i18n.detailed[iso] }}
                  </option>
                  <!-- <option :value="22">
                    {{ i18n.detailed[iso] }} - {{ i18n.day[iso] }}
                  </option>
                  <option :value="23">
                    {{ i18n.detailed[iso] }} - {{ i18n.month[iso] }}
                  </option> -->
                </b-select>
              </b-field>
            </div>
            <div class="column is-1">
              <b-button
                icon-left="eraser"
                icon-pack="fas"
                type="is-danger is-light"
                @click="clearAdvancedSearch"
                expanded
              ></b-button>
            </div>
            <div class="column is-2">
              <b-button
                icon-left="search"
                icon-pack="fas"
                type="is-info"
                @click="advancedSearch(false)"
                expanded
                :loading="loadingStatistics"
                >{{ i18n.search[iso] }}</b-button
              >
            </div>
            <!-- <div class="column is-1">
              <b-button
                icon-left="file-export"
                icon-pack="fas"
                type="is-primary"
                :loading="loadingExport"
                @click="advancedSearch(true)"
                expanded
              ></b-button>
            </div> -->
          </div>
        </b-tab-item>
      </b-tabs>
      <!-- <hr /> -->
      <b-tabs
        v-model="tabFilters2"
        position="is-centered"
        v-if="statistics.length > 0"
      >
        <b-tab-item>
          <template #header>
            <b-icon
              :icon="desglose > 10 && desglose < 20 ? 'cubes' : 'cube'"
              pack="fas"
              type="is-dark"
            ></b-icon>
            <b v-if="desglose > 10 && desglose < 20">{{
              i18n.concentrated[iso]
            }}</b>
            <b v-if="desglose > 20 && desglose < 30">{{
              i18n.detailed[iso]
            }}</b>
          </template>
          <div class="columns" v-if="desglose > 10 && desglose < 20">
            <div class="column is-12">
              <p class="subtitle" v-if="desglose > 11 && desglose < 20">
                {{ i18n.total[iso] }}: {{ statisticsTotal }}
                <span
                  v-if="
                    advancedFilters.Indicador === '2.3' ||
                    advancedFilters.Indicador === '2.4'
                  "
                  ><br />
                  {{ i18n.percentage[iso] }}: {{ statisticsPercentage }}%</span
                >
              </p>
              <b-table
                :data="statistics"
                :paginated="isPaginated"
                :per-page="perPage"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection"
                :pagination-rounded="isPaginationRounded"
                :sort-icon="sortIcon"
                :sort-icon-size="sortIconSize"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                :bordered="isBordered"
                :striped="true"
                :narrowed="isNarrowed"
                :hoverable="true"
                :loading="loadingStatistics"
                :focusable="isFocusable"
                :mobile-cards="hasMobileCards"
              >
                <b-table-column
                  field="Nombre"
                  :label="'-'"
                  centered
                  v-slot="props"
                >
                  {{ props.row.Desglose }}
                </b-table-column>
                <b-table-column
                  field="Total"
                  :label="
                    advancedFilters.Indicador === '3.5'
                      ? 'Reservaciones'
                      : i18n.total[iso]
                  "
                  centered
                  v-slot="props"
                >
                  {{ props.row.Total }}
                  <!-- {{ formatCurrency(props.row.Total) }} -->
                </b-table-column>
                <b-table-column
                  field="Percentage"
                  :label="'%'"
                  centered
                  v-slot="props"
                  :visible="
                    desglose === 11 &&
                    (advancedFilters.Indicador === '2.3' ||
                      advancedFilters.Indicador === '2.4')
                  "
                >
                  {{ props.row.Percentage }}%
                </b-table-column>
                <b-table-column
                  field="Percentage"
                  :label="'Call Center'"
                  centered
                  v-slot="props"
                  :visible="advancedFilters.Indicador === '3.4'"
                >
                  {{ props.row.CallCenterBookings }}
                </b-table-column>
                <b-table-column
                  field="Percentage"
                  :label="'Online'"
                  centered
                  v-slot="props"
                  :visible="advancedFilters.Indicador === '3.4'"
                >
                  {{ props.row.OnlineBookings }}
                </b-table-column>
                <b-table-column
                  field="Percentage"
                  :label="'% Call Center'"
                  centered
                  v-slot="props"
                  :visible="advancedFilters.Indicador === '3.4'"
                >
                  {{ props.row.PercentageCallCenterBookings }}%
                </b-table-column>
                <b-table-column
                  field="Percentage"
                  :label="'% Online'"
                  centered
                  v-slot="props"
                  :visible="advancedFilters.Indicador === '3.4'"
                >
                  {{ props.row.PercentageOnlineBookings }}%
                </b-table-column>
                <b-table-column
                  field="Percentage"
                  :label="'Socios Activos'"
                  centered
                  v-slot="props"
                  :visible="advancedFilters.Indicador === '3.5'"
                >
                  {{ props.row.SociosActivos }}
                </b-table-column>

                <b-table-column
                  field="Percentage"
                  :label="'Participación Socios'"
                  centered
                  v-slot="props"
                  :visible="advancedFilters.Indicador === '3.5'"
                >
                  {{ props.row.Participacion }}%
                </b-table-column>
              </b-table>
              <!-- <div class="column is-1">
                <b-field :label="i18n.quantity[iso]">
                  <b-select v-model="perPage" expanded>
                    <option :value="5">5</option>
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                  </b-select>
                </b-field>
              </div> -->
            </div>
          </div>
          <div class="columns" v-if="desglose > 20 && desglose < 30">
            <div class="column is-12">
              <p class="subtitle">
                {{ i18n.total[iso] }}: {{ statisticsTotal }} <br />
                <span
                  v-if="
                    advancedFilters.Indicador === '2.3' ||
                    advancedFilters.Indicador === '2.4'
                  "
                  ><br />
                  {{ i18n.percentage[iso] }}: {{ statisticsPercentage }}%</span
                >
              </p>
              <b-table
                :data="statistics"
                :paginated="isPaginated"
                :per-page="perPage"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection"
                :pagination-rounded="isPaginationRounded"
                :sort-icon="sortIcon"
                :sort-icon-size="sortIconSize"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                :bordered="isBordered"
                :striped="true"
                :narrowed="isNarrowed"
                :hoverable="true"
                :loading="loadingStatistics"
                :focusable="isFocusable"
                :mobile-cards="hasMobileCards"
                :columns="ColumnasDetallados"
              >
              </b-table>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </section>
  </div>
</template>

<script>
import axios from "axios";
const API_URL = process.env.VUE_APP_API_URL;
import moment from "moment";
import i18n, { agent, columns, loading, statistics } from "../../utils/i18n";

import ModalEditMember from "../ModalEditMember.vue";
// import ModalCommentMember from "./ModalCommentMember.vue";

const today = new Date();

export default {
  data() {
    return {
      isPaginated: true,
      isPaginationSimple: true,
      isPaginationRounded: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 20,
      hasInput: false,
      paginationOrder: "",
      inputPosition: "",
      inputDebounce: "",
      isBordered: false,
      isStriped: true,
      isNarrowed: true,
      isHoverable: true,
      isFocusable: false,
      hasMobileCards: true,
      total: 0,
      loadingExport: false,

      //Statistics
      indicators: [],
      FechaIndicador: null,
      statistics: [],
      desglose: null,
      loadingStatistics: false,
      statisticsTotal: 0,
      statisticsPercentage: 0,
      ColumnasDetallados: [],

      //i18n
      i18n,
      iso: null,

      //Permissions
      permissions: "",

      //Filters
      tabFilters: 0,
      tabFilters2: 0,
      searchMembers: null,
      passValidateSearch: false,
      lastSearchMembers: null,
      clubesName: [],
      staff: [],
      selectedStaff: null,
      loadingClubes: false,
      itemsFilters: [],
      checkedRows: [],
      advancedFilters: {
        Fecha: [],
        Indicador: null,
        Desglose: null,
      },
      validateAdvancedFilters: {
        FechaRegistro: false,
        FechaProcesamiento: false,
        FechaCancelacion: false,
        FechaRenovacion: false,
        FechaCompra: false,
        EstadoMembresia: false,
        EstadoContrato: false,
      },

      /**
       * Members
       */

      members: [],
      loadingMembers: false,

      /**
       * Modal
       */

      isActiveModalEditMember: false,
      dataModalEditMember: null,
      isActiveModalCommentMember: false,
      memberIdModalCommentMember: null,

      /**
       * Dates
       */
      date: new Date(),
      minDate: new Date(
        today.getFullYear() - 80,
        today.getMonth(),
        today.getDate()
      ),
      maxDate: new Date(
        today.getFullYear() + 18,
        today.getMonth(),
        today.getDate()
      ),
    };
  },
  async created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
    });

    //Permissions
    this.permissions = localStorage.getItem("role");

    //Members
    // await this.listAllClubes();
    // await this.listAllUsersStaff();

    // let stateMembers = localStorage.getItem("members");
    // stateMembers = JSON.parse(stateMembers);
    // console.log("stateMembers", stateMembers);
    // if (
    //   stateMembers &&
    //   stateMembers?.exp &&
    //   stateMembers.exp > moment().valueOf() &&
    //   stateMembers.lastSearchMembers &&
    //   stateMembers.lastSearchMembers !== "null"
    // ) {
    //   this.searchMembers = stateMembers.lastSearchMembers;
    //   this.passValidateSearch = true;
    // } else this.advancedSearch(false);

    // await this.advancedSearch(false);

    await this.statsIndicators();
  },
  components: {
    ModalEditMember,
    // ModalCommentMember,
  },
  methods: {
    formatCurrency(value) {
      if (!value) return "-";
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(value);
    },
    async statsAll(filters = {}) {
      try {
        this.loadingStatistics = true;
        const { data } = await axios.post(
          `${API_URL}/catcher/stats-all`,
          filters
        );
        //   console.log("members", data);
        this.statistics = data?.result || [];
        this.statisticsTotal = data?.resultTotal || [];
        this.statisticsPercentage = data?.Percentage || [];
        this.ColumnasDetallados = [];

        if (
          data?.desglose > 20 &&
          data?.desglose < 30 &&
          this.statistics.length > 0
        ) {
          const tmp = { ...this.statistics[0] };
          console.log(tmp, this.statistics[0]);
          for (let i in tmp) {
            console.log(i);
            this.ColumnasDetallados.push({
              field: i,
              label: i,
              centered: true,
            });
          }
        }
        await this.$forceUpdate();
        this.desglose = data?.desglose;

        this.loadingStatistics = false;
      } catch (err) {
        this.loadingStatistics = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error statsAll",
          type: "is-danger",
        });
      }
    },
    async statsIndicators() {
      try {
        // this.allLoading = true;
        const { data } = await axios.get(`${API_URL}/catcher/stats-indicators`);
        //   console.log("members", data);
        this.indicators = data?.indicators || [];

        // this.allLoading = false;
      } catch (err) {
        // this.allLoading = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error statsIndicators",
          type: "is-danger",
        });
      }
    },
    validateSearch(text) {
      // return true;
      // this.passValidateSearch = /^[A-Za-z0-9]+$/gi.test(text);
      this.passValidateSearch = true;
    },
    formatTextBySearch(text, field) {
      if (this.itemsFilters.includes(field)) {
        if (this.lastSearchMembers && text && text !== "") {
          const rgx = new RegExp(this.lastSearchMembers, "ig");
          const insertHtml = (match) => {
            return `<b style="color: #167df0;">${match}</b>`;
          };
          const __name = text.replace(rgx, insertHtml);

          return __name;
        } else {
          return text;
        }
      } else {
        return text;
      }
    },
    openModalEditMember(member) {
      this.dataModalEditMember = member;
      this.isActiveModalEditMember = true;
    },
    restorePassword() {
      this.$buefy.dialog.confirm({
        title: this.i18n.resetPassword[this.iso],
        message: this.i18n.resetPassword__confirm[this.iso],
        cancelText: this.i18n.cancel[this.iso],
        confirmText: this.i18n.accept[this.iso],
        type: "is-info is-light",
        onConfirm: () =>
          this.$buefy.toast.open(
            this.i18n.resetPassword__confirm__success[this.iso]
          ),
      });
    },
    openModalCommentMember(memberId) {
      this.memberIdModalCommentMember = memberId;
      this.isActiveModalCommentMember = true;
    },
    goPath(path) {
      this.$router.push(path);
    },
    changeTab() {
      localStorage.setItem("tabFilters", this.tabFilters);
    },
    async listAllClubes() {
      try {
        this.loadingClubes = true;
        const { data } = await axios.post(`${API_URL}/club/list`, {
          select: "Nombre",
        });
        this.clubesName = data?.clubes || [];
        this.loadingClubes = false;
      } catch (err) {
        this.loadingClubes = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar datos de clubes",
          type: "is-danger",
        });
      }
    },
    advancedSearch(isExport = false) {
      if (isExport) {
        this.$buefy.dialog.confirm({
          message: this.i18n.exportToCsv__msg1[this.iso],
          cancelText: this.i18n.cancel[this.iso],
          confirmText: this.i18n.accept[this.iso],
          type: "is-success",
          onConfirm: async () =>
            await this.exportAllMembers(this.advancedFilters),
        });
        s;
      } else {
        this.currentPage = 1;
        this.statsAll(this.advancedFilters);
      }
    },
    checkAdvancedSearch() {
      let result = false;
      for (let i in this.advancedFilters) {
        if (this.advancedFilters[i]) result = true;
      }
      return result;
    },
    clearAdvancedSearch() {
      this.advancedFilters = {
        Fecha: [],
        Indicador: null,
        Desglose: null,
      };
      this.statistics = [];
      this.desglose = null;
      this.statisticsTotal = 0;
      // this.advancedSearch();
    },
    getMembersStatic(data) {
      let result = [];
      result.push({
        FullNombre: `${data.Nombre} ${data.ApellidoPaterno}`,
        Nombre: data.Nombre,
        ApellidoPaterno: data.ApellidoPaterno,
        Telefono: data.Telefono,
        Email: data.Email,
        Language: data.ContratoId?.Idioma,
        TipoSocioId: data.TipoSocio,
      });

      if (data?.coOwner)
        result.push({
          FullNombre: `${data.coOwner.Nombre} ${data.coOwner.ApellidoPaterno}`,
          Nombre: data.coOwner.Nombre,
          ApellidoPaterno: data.coOwner.ApellidoPaterno,
          Telefono: data.coOwner.Telefono,
          Email: data.coOwner.Email,
          Language: data.ContratoId?.Idioma,
          TipoSocioId: data.coOwner.TipoSocio,
        });

      return result;
    },
    formatDate(date) {
      if (!date || date === 0) return "";
      moment.locale(this.iso);
      return moment(date).format("LL");
    },
    getBeneficiariesStatic(data) {
      let result = [];
      if (data?.beneficiaries)
        result = [
          data.beneficiaries
            .map(
              (b) =>
                `${this.formatTextBySearch(
                  b.Nombre,
                  "Nombre"
                )} ${this.formatTextBySearch(
                  b.ApellidoPaterno,
                  "ApelidoPaterno"
                )}`
            )
            .join(", "),
        ];

      console.log("result", result);
      return result.filter((b) => b && b !== "");
    },
    async exportAllMembers(filters = {}) {
      try {
        this.loadingExport = true;
        // const { data } = await axios.post(`${API_URL}/renewals/statistics`, {
        //   ...filters,
        //   isExport: true,
        // });

        // if (data?.Totales) await this.createCsv(data?.Totales, "Totales");
        // if (data?.TotalesxAgente)
        //   await this.createCsv(data?.TotalesxAgente, "TotalesxAgente");
        // if (data?.TotalesxYears)
        //   await this.createCsv(data?.TotalesxYears, "TotalesxYears");
        // if (data?.PagosDiferidosxAgente)
        //   await this.createCsv(
        //     data?.PagosDiferidosxAgente,
        //     "PagosDiferidosxAgente"
        //   );
        // if (data?.Detallado) await this.createCsv(data?.Detallado, "Detallado");

        this.loadingExport = false;
      } catch (err) {
        this.loadingExport = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al exportar datos",
          type: "is-danger",
        });
      }
    },
    createCsv(data, name) {
      const blob = new Blob([data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", `${name}.csv`);
      a.click();
    },
    checkValidateAdvancedFilters() {
      if (this.advancedFilters.contractStatus === 1) {
        this.validateAdvancedFilters.FechaCancelacion = true;
        this.validateAdvancedFilters.FechaRenovacion = true;

        this.advancedFilters.FechaCancelacion = [];
        this.advancedFilters.FechaRenovacion = [];
      } else {
        this.validateAdvancedFilters.FechaCancelacion = false;
        this.validateAdvancedFilters.FechaRenovacion = false;
      }
    },
    async listAllUsersStaff() {
      try {
        // this.loadingClubes = true;
        const { data } = await axios.post(`${API_URL}/system/list-staff`);
        this.staff = data?.users || [];
        // this.loadingClubes = false;
      } catch (err) {
        // this.loadingClubes = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar datos de staff",
          type: "is-danger",
        });
      }
    },
    checkContract(a, b) {
      // console.log("row", this.checkedRows);
      return true;
    },
    async activateAllContractsFetch() {
      try {
        // this.loadingClubes = true;
        await axios.put(
          `${API_URL}/catcher/edit-status-membership-massive/contract`,
          {
            contractIds: this.checkedRows.map((c) => c.ContratoId.Id),
          }
        );
        this.$buefy.toast.open({
          message: this.i18n.massiveActivateContracts__msg1[this.iso],
          type: "is-success",
        });
        this.checkedRows = [];
        this.advancedSearch();
        // this.loadingClubes = false;
      } catch (err) {
        // this.loadingClubes = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error",
          type: "is-danger",
        });
      }
    },
    async activateAllContracts() {
      if (this.checkedRows.length > 0) {
        this.$buefy.dialog.confirm({
          message: this.i18n.massiveActivateContracts__msg2[this.iso].replace(
            "{{total}}",
            this.checkedRows.length
          ),
          cancelText: this.i18n.cancel[this.iso],
          confirmText: this.i18n.accept[this.iso],
          type: "is-success",
          onConfirm: async () => await this.activateAllContractsFetch(),
        });
      }
    },
    async assignStaffToContractsFetch() {
      if (this.checkedRows.length > 0) {
        try {
          // this.loadingClubes = true;
          await axios.post(`${API_URL}/catcher/assign-staff/contract`, {
            contractIds: this.checkedRows.map((c) => c.ContratoId.Id),
            staff: this.selectedStaff,
          });
          this.$buefy.toast.open({
            message: this.i18n.massiveAssignContracts__msg1[this.iso],
            type: "is-success",
          });
          this.checkedRows = [];
          this.selectedStaff = null;
          this.advancedSearch();
          // this.loadingClubes = false;
        } catch (err) {
          // this.loadingClubes = false;
          console.log(err);
          this.$buefy.toast.open({
            message: "Error",
            type: "is-danger",
          });
        }
      }
    },
    async assignStaffToContracts() {
      if (this.checkedRows.length > 0 && this.selectedStaff) {
        this.$buefy.dialog.confirm({
          message: this.i18n.massiveAssignContracts__msg2[this.iso]
            .replace("{{total}}", this.checkedRows.length)
            .replace("{{staff}}", this.selectedStaff),
          cancelText: this.i18n.cancel[this.iso],
          confirmText: this.i18n.accept[this.iso],
          type: "is-success",
          onConfirm: async () => await this.assignStaffToContractsFetch(),
        });
      }
    },
    checkSubscription(contract) {
      const now = Date.now();
      if (
        contract &&
        contract?.FechaRenovacion &&
        contract?.FechaRenovacion < now
      )
        return false;
      else return true;
    },
    checkMembership(contract) {
      if (contract && contract?.EstadoMembresia === true) return 1;
      else if (contract && contract?.EstadoMembresia === false) return 2;
      else return 3;
    },
    changeDateIndicator(indicatorId) {
      const indicator = this.indicators.find((i) => i.id === indicatorId);
      if (indicator) this.FechaIndicador = indicator[`date_${this.iso}`];
      else this.FechaIndicador = null;
    },
  },
};
</script>

<style>
tr.is-total {
  background: #ecf4fe;
  color: #35374b;
}
</style>
